import * as ambassadorWixBookingsAvailabilityV2TimeSlot from './bookings-availability-v2-time-slot-availability-time-slots.http.js';
import * as ambassadorWixBookingsAvailabilityV2TimeSlotTypes from './bookings-availability-v2-time-slot-availability-time-slots.types.js';
import * as ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes from './bookings-availability-v2-time-slot-availability-time-slots.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listAvailabilityTimeSlots(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes.ListAvailabilityTimeSlotsRequest,
  ambassadorWixBookingsAvailabilityV2TimeSlotTypes.ListAvailabilityTimeSlotsRequest,
  ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes.ListAvailabilityTimeSlotsResponse,
  ambassadorWixBookingsAvailabilityV2TimeSlotTypes.ListAvailabilityTimeSlotsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsAvailabilityV2TimeSlot.listAvailabilityTimeSlots(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/time-slots',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAvailabilityTimeSlot(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes.GetAvailabilityTimeSlotRequest,
  ambassadorWixBookingsAvailabilityV2TimeSlotTypes.GetAvailabilityTimeSlotRequest,
  ambassadorWixBookingsAvailabilityV2TimeSlotUniversalTypes.GetAvailabilityTimeSlotResponse,
  ambassadorWixBookingsAvailabilityV2TimeSlotTypes.GetAvailabilityTimeSlotResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsAvailabilityV2TimeSlot.getAvailabilityTimeSlot(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/time-slots/get',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TimeSlot as TimeSlotOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  EventInfo as EventInfoOriginal,
  WaitingList as WaitingListOriginal,
  BookingPolicyViolations as BookingPolicyViolationsOriginal,
  AvailableResources as AvailableResourcesOriginal,
  Resource as ResourceOriginal,
  NestedTimeSlot as NestedTimeSlotOriginal,
  NonBookableReasons as NonBookableReasonsOriginal,
  ListAvailabilityTimeSlotsRequest as ListAvailabilityTimeSlotsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  CustomerChoices as CustomerChoicesOriginal,
  ResourceType as ResourceTypeOriginal,
  ListAvailabilityTimeSlotsResponse as ListAvailabilityTimeSlotsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  GetAvailabilityTimeSlotRequest as GetAvailabilityTimeSlotRequestOriginal,
  GetAvailabilityTimeSlotRequestCustomerChoices as GetAvailabilityTimeSlotRequestCustomerChoicesOriginal,
  GetAvailabilityTimeSlotResponse as GetAvailabilityTimeSlotResponseOriginal,
  ListMultiServiceAvailabilityTimeSlotsRequest as ListMultiServiceAvailabilityTimeSlotsRequestOriginal,
  Service as ServiceOriginal,
  V2CustomerChoices as V2CustomerChoicesOriginal,
  ListMultiServiceAvailabilityTimeSlotsResponse as ListMultiServiceAvailabilityTimeSlotsResponseOriginal,
  GetMultiServiceAvailabilityTimeSlotRequest as GetMultiServiceAvailabilityTimeSlotRequestOriginal,
  GetMultiServiceAvailabilityTimeSlotResponse as GetMultiServiceAvailabilityTimeSlotResponseOriginal,
  ListEventTimeSlotsRequest as ListEventTimeSlotsRequestOriginal,
  ListEventTimeSlotsResponse as ListEventTimeSlotsResponseOriginal,
  GetEventTimeSlotRequest as GetEventTimeSlotRequestOriginal,
  GetEventTimeSlotResponse as GetEventTimeSlotResponseOriginal,
  ListAvailabilityTimeSlotsApplicationErrors as ListAvailabilityTimeSlotsApplicationErrorsOriginal,
  GetAvailabilityTimeSlotApplicationErrors as GetAvailabilityTimeSlotApplicationErrorsOriginal,
} from './bookings-availability-v2-time-slot-availability-time-slots.types.js';
